export const ka = {
  header: {
    title: 'ექიმი ხოშტარია',
  },
  nav: {
    about: 'ჩვენს შესახებ',
    services: 'სერვისები',
    education: 'საგანმანათლებლო რესურსები',
    askDoctor: 'შეეკითხეთ ექიმს',
    contact: 'კონტაქტი'
  },
  education: {
    title: 'საგანმანათლებლო რესურსები',
    subtitle: 'შერჩეული ვიდეო კონტენტი ქალთა ჯანმრთელობის უკეთ გასაგებად',
    georgian: {
      title: 'საგანმანათლებლო რესურსები ქართულ ენაზე',
      watchVideo: 'ვიდეოს ნახვა'
    },
    english: {
      title: 'საგანმანათლებლო რესურსები ინგლისურ ენაზე',
      watchVideo: 'ვიდეოს ნახვა'
    },
    russian: {
      title: 'საგანმანათლებლო რესურსები რუსულ ენაზე',
      watchVideo: 'ვიდეოს ნახვა'
    }
  },
  hero: {
    title: 'ექიმი მამუკა ხოშტარია',
    subtitle: 'აღიარებული მეან-გინეკოლოგი 40 წელზე მეტი გამოცდილებით ქალთა ჯანმრთელობის სფეროში',
    cta: 'ჩაეწერეთ ვიზიტზე',
  },
  stats: {
    childbirths: {
      number: '20,000+',
      text: 'წარმატებული მშობიარობა',
    },
    complications: {
      number: '2,000+',
      text: 'გართულებული შემთხვევა',
    },
    surgeries: {
      number: '3,000+',
      text: 'რთული ოპერაცია',
    },
    experience: {
      number: '40+',
      text: 'წლიანი გამოცდილება',
    },
  },
  expertise: {
    title: 'ექსპერტ სფეროები და სპეციალიზაცია',
    subtitle: 'მრავალწლიანი გამოცდილებით მეანობასა და გინეკოლოგიაში, ექიმმა მამუკა ხოშტარიამ წარმატებით უმკურნალა ათასობით პაციენტს, როგორც რუტინული მშობიარობების, ასევე რთული ქირურგიული პროცედურების დროს.',
    services: {
      obstetrics: {
        title: 'სამეანო მომსახურება',
        description: 'სრული სამეანო მომსახურება, პრენატალური და პოსტნატალური სერვისებით, როგორც რუტინული, ასევე მაღალი რისკის ორსულობის მართვით.',
      },
      surgery: {
        title: 'გინეკოლოგიური ქირურგია',
        description: 'სპეციალიზებული რთული გინეკოლოგიური პროცედურები, მათ შორის ონკოლოგიური და უროგინეკოლოგიური ოპერაციები.',
      },
      health: {
        title: 'ქალთა ჯანმრთელობა',
        description: 'სრული ქალთა ჯანმრთელობის სერვისები ცხოვრების ყველა ეტაპზე.',
      },
      additional: {
        title: 'დამატებითი სერვისები',
        description: 'სპეციალიზებული სერვისები, მათ შორის ფერტილობის მკურნალობა, მინიმალურად ინვაზიური პროცედურები და პრევენციული კონსულტაციები.',
      },
    },
  },
  contact: {
    title: 'საკონტაქტო ინფორმაცია',
    subtitle: 'დაჯავშნეთ ვიზიტი ან დაგვიკავშირდით ნებისმიერი შეკითხვით.',
    getInTouch: 'დაგვიკავშირდით',
    mobile: 'მობილური',
    office: 'ოფისი',
    currentWorkplaces: 'მიმდინარე სამუშაო ადგილები',
    phone: '+995 599 43 66 77',
    landline: '+995 032 2 52 05 25',
    email: 'mamuka_khoshtaria@yahoo.com',
    clinics: {
      openHeart: 'ღია გული - საუნივერსიტეტო კლინიკა',
      barbara: 'რეპროდუქციული ჯანმრთელობის კლინიკა ბარბარე'
    },
    hours: 'ორშაბათი - პარასკევი: 9:00 - 18:00',
    appointments: 'ვიზიტები ხელმისაწვდომია',
  },
  footer: {
    copyright: '© {year} ექიმი მამუკა ხოშტარია. ყველა უფლება დაცულია.',
  },
  aiChat: {
    title: 'AI სამედიცინო ასისტენტი',
    backToHome: 'მთავარ გვერდზე დაბრუნება',
    description: 'AI ასისტენტი დაგეხმარებათ:',
    capabilities: {
      general: 'ზოგადი სამედიცინო ინფორმაცია და გაიდლაინები',
      symptoms: 'გავრცელებული სიმპტომები და მდგომარეობები',
      recommendations: 'ძირითადი ჯანმრთელობის რეკომენდაციები',
      pregnancy: 'ორსულობა და ქალთა ჯანმრთელობის ინფორმაცია'
    },
    disclaimer: 'გთხოვთ გაითვალისწინოთ: AI გაწვდით მხოლოდ ზოგად ინფორმაციას და არ ჩაანაცვლებს პროფესიონალურ სამედიცინო რჩევას.',
    askDoctor: {
      title: 'შეეკითხეთ ექიმს',
      description: 'გაქვთ კონკრეტული შეკითხვა? დატოვეთ თქვენი შეკითხვა აქ და ექიმი პირადად განიხილავს და უპასუხებს თქვენს მოთხოვნას სამუშაო საათებში. შეგიძლიათ დაურთოთ შესაბამისი სამედიცინო დოკუმენტები, რაც დაეხმარება ექიმს უკეთ გაიგოს თქვენი მდგომარეობა.',
      instructions: {
        title: 'როგორ დავსვათ შეკითხვა',
        steps: 'მიუთითეთ თქვენი საკონტაქტო ინფორმაცია\nდაწერეთ თქვენი შეკითხვა დეტალურად\nდაურთეთ შესაბამისი სამედიცინო დოკუმენტები (არასავალდებულო)\nგააგზავნეთ შეკითხვა და დაელოდეთ პასუხს ელ-ფოსტაზე'
      },
      attachments: {
        title: 'დამხმარე დოკუმენტები',
        description: 'შეგიძლიათ დაურთოთ შესაბამისი სამედიცინო დოკუმენტები:',
        voice: {
          title: 'ხმის ჩაწერა',
          description: 'შეგიძლიათ ჩაიწეროთ თქვენი ხმა კითხვის დეტალურად ასახსნელად',
          start: 'ჩაწერის დაწყება',
          stop: 'ჩაწერის შეწყვეტა',
          delete: 'ჩანაწერის წაშლა',
          duration: 'ჩანაწერის ხანგრძლივობა: {seconds} წამი',
          instructions: 'დააჭირეთ ხმოვანი შეტყობინების ჩასაწერად. ისაუბრეთ გარკვევით და დეტალურად აღწერეთ თქვენი სამედიცინო პრობლემა.',
          processing: 'მუშავდება...',
          error: 'ჩაწერის შეცდომა',
          tryAgain: 'გთხოვთ სცადოთ ჩაწერა ხელახლა.',
          recordedLabel: 'ხმოვანი შეტყობინება ჩაწერილია'
        },
        types: 'ლაბორატორიული ანალიზების შედეგები\nსამედიცინო გამოსახულებების დასკვნები\nწინა სამედიცინო ჩანაწერები\nრეცეპტების დოკუმენტები',
        limits: 'მისაღები ფორმატები: სურათები, PDF, DOC. მაქსიმალური ზომა: 10MB თითო ფაილზე',
        button: 'დოკუმენტების დამატება',
        remove: 'წაშლა',
        subtitle: 'ანალიზების შედეგები და სამედიცინო დოკუმენტები ეხმარება ექიმს უფრო ზუსტად გიპასუხოთ',
        note: 'მაქსიმუმ 30 ფაილი, თითო 10MB-მდე. PDF და Word ფაილებიდან ტექსტი ავტომატურად იკითხება.',
        processingCount: 'მუშავდება {count} ფაილი...',
        uploadingTitle: 'ფაილების ატვირთვა',
        inProgress: 'მიმდინარეობს: {count} ფაილი',
        pleaseWait: 'გთხოვთ დაელოდოთ, თქვენი ფაილები მუშავდება...',
        listTitle: 'მიმაგრებული ფაილები',
        counter: '{current}/{max} ფაილი',
        processingShort: 'მუშავდება...',
        pageProgress: 'გვერდი {current} / {total}',
        timeRemaining: 'დარჩა {time}',
        extractedOk: 'ტექსტი ამოღებულია ({pages} გვერდი, {chars}k სიმბოლო)',
        previewLabel: 'ამოღებული ტექსტის ნიმუში:',
        imageReady: 'სურათი მზადაა ({size} MB)',
        fileReady: 'მზადაა ({size} MB)',
        errorLabel: 'შეცდომა',
        methodOcr: 'OCR',
        methodStandard: 'ტექსტი'
      },
      emailNote: 'პასუხს მიიღებთ ელ-ფოსტაზე',
      contact: {
        title: 'საკონტაქტო ინფორმაცია',
        subtitle: 'ექიმის პასუხს მიიღებთ ელ-ფოსტაზე'
      },
      questionHint: 'აღწერეთ თქვენი პრობლემა რაც შეიძლება დეტალურად — ან ჩაწერეთ ხმოვანი შეტყობინება ქვემოთ',
      orSpeak: 'ან ჩაწერეთ ხმოვანი შეტყობინება',
      optionalTag: 'არასავალდებულო',
      namePlaceholder: 'თქვენი სახელი',
      emailPlaceholder: 'თქვენი ელ-ფოსტა',
      phonePlaceholder: 'ტელეფონი (არასავალდებულო)',
      label: 'თქვენი შეკითხვა',
      placeholder: 'ჩაწერეთ თქვენი შეკითხვა აქ...',
      submit: 'შეკითხვის გაგზავნა',
      submitSaving: 'შეკითხვა ინახება…',
      submitUploading: 'ფაილები იტვირთება…',
      error: 'შეკითხვის გაგზავნისას მოხდა შეცდომა. გთხოვთ სცადოთ ხელახლა.',
      success: {
        title: 'მადლობა თქვენი შეკითხვისთვის!',
        message: 'ექიმი განიხილავს და უპასუხებს თქვენს მოთხოვნას ელ-ფოსტით რაც შეიძლება მალე.',
        askAnother: 'დასვით სხვა შეკითხვა'
      }
    }
  },
  askDoctor: {
    form: {
      namePlaceholder: 'თქვენი სახელი',
      emailPlaceholder: 'თქვენი ელ-ფოსტა'
    }
  },
  chat: {
    title: 'AI სამედიცინო ასისტენტი',
    subtitle: 'მიიღეთ ექსპერტული სამედიცინო რჩევები 24/7',
    disk: {
      medicalAssistance: 'სამედიცინო დახმარება',
      healthGuidance: 'ჯანმრთელობის გზამკვლევი',
      expertSupport: 'ექსპერტის მხარდაჭერა',
      available: '24/7 ხელმისაწვდომი'
    },
    welcome: 'დამისვით ნებისმიერი სამედიცინო შეკითხვა',
    placeholder: 'დაწერეთ თქვენი შეკითხვა...',
    error: 'ბოდიში, მაგრამ დაკავშირება ვერ ხერხდება. გთხოვთ სცადოთ ხელახლა.',
    online: 'ონლაინ',
    typing: 'წერს...',
    thinking: 'ფიქრობს...',
    sources: 'წყაროები',
    reasoning: {
      label: 'ღრმა ანალიზი',
      tooltip: 'ჩართვისას ასისტენტი უფრო ღრმად აანალიზებს და ეძებს ინტერნეტში უკეთესი პასუხებისთვის.',
      on: 'ჩართ.',
      off: 'გამორთ.'
    },
    inputAriaLabel: 'შეტყობინების შეყვანა',
    sendAriaLabel: 'შეტყობინების გაგზავნა',
    sectionTitle: 'AI ასისტენტი',
    sectionSubtitle: 'გამოიყენეთ AI ჩატბოტი ხშირ კითხვებზე პასუხის გასაცემად',
    quickReplies: {
      appointments: 'როგორ დავჯავშნო ვიზიტი?',
      services: 'რა სერვისებს გთავაზობთ?',
      location: 'სად მდებარეობს თქვენი კლინიკა?'
    },
    actions: {
      newChat: 'ახალი საუბარი',
      history: 'საუბრების ისტორია',
      collapse: 'ჩაკეცვა',
      attach: 'ფაილების მიმაგრება',
      remove: 'ფაილის წაშლა',
      editSend: 'რედაქტირება და გაგზავნა'
    },
    history: {
      title: 'საუბრების ისტორია',
      back: 'ჩატში დაბრუნება',
      empty: 'წინა საუბრები არ მოიძებნა',
      view: 'ნახვა',
      delete: 'წაშლა',
      confirmDelete: 'წავშალოთ ეს საუბარი? ამ მოქმედების გაუქმება შეუძლებელია.',
      loadFailed: 'საუბრების ჩატვირთვა ვერ მოხერხდა',
      deleteFailed: 'საუბრის წაშლა ვერ მოხერხდა'
    },
    attachment: {
      preview: 'ამოღებული ტექსტი',
      extracted: 'ტექსტი ამოღებულია',
      pages: 'გვერდი',
      page: 'გვერდი',
      error: 'შეცდომა'
    },
    voice: {
      start: 'ხმოვანი შეტყობინების ჩაწერა',
      stop: 'ჩაწერის შეჩერება',
      noSpeech: 'ჩანაწერში მეტყველება ვერ აღმოჩნდა. გთხოვთ სცადოთ ხელახლა.',
      failed: 'ჩანაწერის გაშიფვრა ვერ მოხერხდა.'
    },
    editForm: {
      title: 'პასუხის რედაქტირება და გაგზავნა',
      emailLabel: 'პაციენტის ელფოსტა *',
      phoneLabel: 'პაციენტის ტელეფონი',
      questionLabel: 'თავდაპირველი შეკითხვა',
      originalLabel: 'AI-ის თავდაპირველი პასუხი',
      responseLabel: 'პასუხის რედაქტირება *',
      emailPlaceholder: 'შეიყვანეთ პაციენტის ელფოსტა',
      phonePlaceholder: 'შეიყვანეთ პაციენტის ტელეფონი',
      questionPlaceholder: 'შეიყვანეთ თავდაპირველი შეკითხვა',
      responsePlaceholder: 'დაარედაქტირეთ AI-ის პასუხი აქ...',
      downloadPdf: 'PDF-ის ჩამოტვირთვა',
      cancel: 'გაუქმება',
      send: 'პაციენტთან გაგზავნა',
      sending: 'იგზავნება...'
    }
  },
  admin: {
    nav: {
      backToHome: 'მთავარზე დაბრუნება',
      chatHistory: 'ჩატის ისტორია',
      logout: 'გასვლა'
    },
    aiAssistant: {
      title: 'AI ასისტენტი',
      subtitle: 'გამოიყენეთ AI ჩატბოტი ხშირი შეკითხვების პასუხებში დასახმარებლად'
    },
    questions: {
      title: 'პაციენტთა შეკითხვები',
      subtitle: 'მართეთ და უპასუხეთ პაციენტთა შეკითხვებს',
      filterAll: 'ყველა შეკითხვა',
      filterPending: 'მოლოდინში',
      filterAnswered: 'პასუხგაცემული',
      statusAnswered: 'პასუხგაცემული',
      statusPending: 'მოლოდინში',
      newReply: 'ახალი პასუხი',
      questionPreviewLabel: 'შეკითხვა',
      respond: 'პასუხი',
      pdf: 'PDF',
      delete: 'წაშლა',
      questionDetails: 'შეკითხვის დეტალები',
      patientQuestion: 'პაციენტის შეკითხვა',
      aiInitialResponse: 'AI-ის საწყისი პასუხი',
      yourResponse: 'თქვენი პასუხი',
      generatedAt: 'შეიქმნა: {date}',
      sentAt: 'გაიგზავნა: {date}',
      voiceMessage: 'ხმოვანი შეტყობინება',
      durationSeconds: 'ხანგრძლივობა: {seconds} წამი',
      attachments: 'დანართები',
      answeredOn: 'პასუხგაცემული: {date}',
      emptyTitle: 'შეკითხვები ჯერ არ არის',
      emptyMessage: 'პაციენტთა შეკითხვები აქ გამოჩნდება მათი გამოგზავნისთანავე.',
      errorTitle: 'შეცდომა',
      previewDownload: 'ჩამოტვირთვა',
      confirmDelete: 'დარწმუნებული ხართ, რომ გსურთ ამ შეკითხვის წაშლა? ეს მოქმედება ვერ გაუქმდება.',
      responseSent: 'პასუხი წარმატებით გაიგზავნა!'
    },
    respondForm: {
      title: 'პასუხის გაცემა პაციენტს',
      patientQuestionLabel: 'პაციენტის შეკითხვა',
      aiResponseLabel: 'AI-ის გენერირებული პასუხი',
      yourResponseLabel: 'თქვენი პასუხი',
      responsePlaceholder: 'დაარედაქტირეთ ან დაწერეთ პასუხი აქ...',
      downloadPdf: 'PDF-ის ჩამოტვირთვა',
      cancel: 'გაუქმება',
      send: 'პასუხის გაგზავნა',
      sending: 'იგზავნება...'
    }
  },
};